import { Slider, SliderProps, useTheme } from '@mui/material'
import { Mark } from '@mui/material/Slider/useSlider.types'
import { formatPercentage } from '../utils/string'

export interface GeneratorRelayThresholdSliderProps extends Omit<SliderProps, 'value'> {
  value: [number, number]
  minDistance?: number
}

export default function GeneratorRelayThresholdSlider({
  value,
  minDistance = 0,
  ...props
}: GeneratorRelayThresholdSliderProps) {
  const theme = useTheme()

  const marks: Mark[] = [
    {
      value: 0,
      label: '0%'
    },
    // {
    //   value: 10,
    //   label: '10%'
    // },
    {
      value: 20,
      label: '20%'
    },
    // {
    //   value: 30,
    //   label: '30%'
    // },
    {
      value: 40,
      label: '40%'
    },
    // {
    //   value: 50,
    //   label: '50%'
    // },
    {
      value: 60,
      label: '60%'
    },
    // {
    //   value: 70,
    //   label: '70%'
    // },
    {
      value: 80,
      label: '80%'
    },
    // {
    //   value: 90,
    //   label: '90%'
    // },
    {
      value: 100,
      label: '100%'
    }
  ]

  return (
    <Slider
      value={value}
      track="inverted"
      valueLabelFormat={(value) => formatPercentage(value, true, 2)}
      marks={marks}
      valueLabelDisplay="auto"
      disableSwap
      sx={{
        height: 8,

        // Hide default track
        '& .MuiSlider-track': {
          background: 'transparent',
          border: 'none'
        },

        // Custom rail with gradient
        '& .MuiSlider-rail': {
          opacity: 1,
          background: `linear-gradient(
            to right,
            ${theme.palette.success.light} 0%,
            ${theme.palette.success.light} ${value[0]}%,
            ${
              minDistance
                ? theme.palette.warning.light + ' ' + (value[0] + 0.001)
                : theme.palette.divider + ' ' + (value[0] + 0.001)
            }%,
            ${
              minDistance
                ? theme.palette.warning.light +
                  ' ' +
                  (value[0] + minDistance < value[1] - 0.001
                    ? value[0] + minDistance
                    : value[1] - 0.001)
                : theme.palette.divider + ' ' + (value[0] + 0.001)
            }%,
            
            ${
              minDistance
                ? theme.palette.divider +
                  ' ' +
                  (value[0] + minDistance + 0.001 < value[1] - 0.001
                    ? value[0] + minDistance + 0.001
                    : value[1] - 0.001)
                : theme.palette.divider + ' ' + (value[0] + 0.001)
            }%,

            ${theme.palette.divider} ${value[1] - 0.001}%,
            ${theme.palette.error.light} ${value[1]}%,
            ${theme.palette.error.light} 100%
          )`
        }
      }}
      {...props}
    />
  )
}
